import React, { Fragment, useEffect, useState } from "react";
import { CustomConfirmLayer } from "../../../components/UI/Dialog";
import { openLayerFn } from "../../Layout";

export default (props) => {
  const getParam = window.location.hash.split("/?")[1].split("&");

  const getData = (param) => {
    return param.split("=")[1];
  };

  const [dialog, setDialog] = useState({
    type: "check",
    title: "카드등록 실패",
    msg: decodeURIComponent(getData(getParam[1])),
    msg2: "",
    data: {},
  });

  useEffect(() => {
    if (getData(getParam[0]) == "E000") {
      window.parent.postMessage({ messageId: "reload" }, "*");
    } else {
      openLayerFn($("#cstmCnfmLayer"));
    }
  }, []);
  return (
    <Fragment>
      <div>빈 페이지</div>
      <div>{getData(getParam[0])}</div>
      <CustomConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        msg2={dialog.msg2}
        handleConfirmCB={() => window.parent.postMessage({ messageId: "reload" }, "*")}
        handleConfirmCBText={"확인"}
        setCookieBtn={false}
      />
    </Fragment>
  );
};
